import _ from 'underscore'

import React, { useEffect, useRef, useState } from 'react'

import styled from 'styled-components'

import Dropdown from 'components/Dropdown'
import Search from 'components/Search'

import { streetAddress, cityStateZip, customerDisplayName } from 'helpers/formatters'
import { scrubText } from 'helpers/inputCleaners'

import { color } from 'styles/colors'

import { CustomerBase } from 'types/Customer'

type Props = {
  isDropdownOpen: boolean
  onCloseDropdown: () => void
  customers: Array<CustomerBase>
  onSelectCustomerCallback: (selectedCustomer: CustomerBase) => void
  className?: string
}

const SelectCustomerDropdown = ({ isDropdownOpen, onCloseDropdown, customers, onSelectCustomerCallback, className = '' }: Props) => {
  const [inputValue, setInputValue] = useState<string | null>(null)
  const searchInputRef = useRef<HTMLInputElement>(null)

  const matchedCustomers = _.filter(customers, customer => customerDisplayName(customer.firstName, customer.lastName, customer.companyName)?.toLowerCase().includes(inputValue?.toLowerCase()))

  useEffect(() => {
    searchInputRef.current?.focus()
  }, [searchInputRef, isDropdownOpen])

  return (
    <S.Dropdown isOpen={isDropdownOpen} onClose={onCloseDropdown} ariaLabelsToIgnoreOnOutsideClick={['search customers', 'select customer']} {...{ className }}>
      <S.DropdownContent>
        <S.Search
          ariaLabel="search customers"
          placeholder="Search"
          ref={searchInputRef}
          value={inputValue || ''}
          showClearIcon={false}
          onClickClearIcon={() => setInputValue(null)}
          onChange={(newValue) => setInputValue(scrubText(newValue, true))}
          onSearch={(newValue) => setInputValue(scrubText(newValue, true))}
          hideSearchButton
        />
        {_.map(matchedCustomers, (customer) => {
          return (
            <S.CustomerItem key={customer.id} onClick={() => onSelectCustomerCallback(customer)}>
              <S.Name>{customerDisplayName(customer.firstName, customer.lastName, customer.companyName)}</S.Name>
              <div>{streetAddress(customer.address1, customer.address2)}</div>
              <div>{cityStateZip(customer.city, customer.state, customer.zip)}</div>
            </S.CustomerItem>
          )
        })}
      </S.DropdownContent>
    </S.Dropdown>
  )
}

export default SelectCustomerDropdown

const S = {
  Dropdown: styled(Dropdown)`
    background: ${color('paneBackground')};
    width: 250px;
    border: 1px solid ${color('border')};
  `,
  DropdownContent: styled.div`
    max-height: 200px;
    overflow-y: auto;
  `,
  Search: styled(Search)<{ ariaLabel: string, placeholder: string, value: string, showClearIcon: boolean,
    onClickClearIcon: () => void, onChange: (newValue) => void, onSearch: (value) => void }>`
    display: inline-block;
    margin: 5px 5px 0px 5px;

    & > input:first-of-type {
      width: 100%;
      height: 35px;
    }
  `,
  CustomerItem: styled.div`
    padding: 0px 5px 5px 5px;

    &:hover {
      background: ${color('backgroundHover')};
    }
  `,
  Name: styled.div`
    font-weight: bold;
  `
}
